import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _Edit(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", strokeWidth: 2, d: "M15.188 5.424c.424.045.762.24 1.03.445.285.217.59.525.903.838l.172.172c.313.313.621.618.838.902.234.308.455.705.455 1.219s-.22.911-.455 1.219c-.217.284-.525.589-.838.902l-7.194 7.194c-.157.157-.36.374-.624.523s-.554.213-.77.267l-2.608.65-.002.002-.044.01c-.148.038-.37.096-.564.115-.206.02-.658.027-1.027-.342s-.362-.82-.342-1.027c.02-.195.077-.416.114-.564l.664-2.654c.053-.216.117-.506.266-.77.15-.263.365-.467.523-.624l7.194-7.194c.313-.313.618-.621.902-.838.308-.234.705-.455 1.219-.455z" }),
            React.createElement("path", { fill: "currentColor", d: "m12.5 7.5 3-2 3 3-2 3z" })));
}
const Edit = forwardRef(_Edit);
export { Edit };
